import { PaymentPeriod, UserSubscriptionStatus } from "../enums";

// Single source of truth for statuses that give the user an active subscription.
const activeSubscriptionStatuses: string[] = [
  UserSubscriptionStatus.ACTIVE,
  UserSubscriptionStatus.TRIAL,
  UserSubscriptionStatus.IN_DUNNING,
];

export const isActiveSubscriptionStatus = (status?: string) =>
  !!status && activeSubscriptionStatuses.includes(status);

export const isAnnualPeriod = (period?: PaymentPeriod) =>
  period === PaymentPeriod.Year;

export const getPeriodLengthInMonths = (period: PaymentPeriod) => {
  if (period === PaymentPeriod.Month) return 1;
  if (period === PaymentPeriod.HalfYear) return 6;
  if (period === PaymentPeriod.Year) return 12;

  return 1;
};
